import type { PropsWithChildren } from "react";

export const NavGroup = ({ children }: PropsWithChildren<unknown>) => (
  <div className="flex w-full items-center gap-6 overflow-auto lg:justify-center lg:overflow-visible">
    <ul className="flex list-none items-center gap-6">{children}</ul>
  </div>
);
